import { render, staticRenderFns } from "./bankAsideControls.vue?vue&type=template&id=a0b6b24c"
import script from "./bankAsideControls.vue?vue&type=script&lang=js"
export * from "./bankAsideControls.vue?vue&type=script&lang=js"
import style0 from "./bankAsideControls.vue?vue&type=style&index=0&id=a0b6b24c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports